import { format } from 'date-fns';

/**
 * Returns a date string without a timestamp.
 *
 * @param value The date string.
 * @returns string
 */
export function dateWithoutTimestamp(value: string): string {
  if (!value) {
    return '';
  }

  return value.split('T')[0];
}

/**
 * Returns a date string with a timestamp.
 *
 * This is useful for ensuring that a `Date` created from a string in
 * `yyyy-mm-dd` format yields the same date.
 *
 * @param value The date string.
 * @returns string
 */
export function dateWithNeutralTimestamp(value: string): string {
  if (!value) {
    return '';
  }

  const date = dateWithoutTimestamp(value);

  return `${date}T00:00:00`;
}

/**
 * Returns a date string in `mm/dd/yyyy` format.
 *
 * @param value The date string.
 * @returns string
 */
export function formatFymDate(value: string): string {
  if (!value) {
    return '';
  }

  return format(new Date(dateWithNeutralTimestamp(value)), 'MM/dd/yyyy');
}
